export default __webpack_public_path__ + "static/media/room-landing-web.4548d7e0.webp";